module.exports = __webpack_public_path__ + "static/media/kakao.8affa4f7.svg";